export const WaveDivider = ({ topColor = "#ffffff", bottomColor = "#F5F5F5", flip = false }) => (
  <div style={{ background: topColor, lineHeight: 0 }}>
    <svg
      viewBox="0 0 1440 80"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      style={{ display: "block", transform: flip ? "scaleY(-1)" : "none" }}
      className="w-full h-16 md:h-20"
    >
      <path
        d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
        fill={bottomColor}
      />
    </svg>
  </div>
);

export const DiagonalDivider = ({ topColor = "#003366", bottomColor = "#ffffff" }) => (
  <div style={{ background: topColor, lineHeight: 0 }}>
    <svg
      viewBox="0 0 1440 80"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      style={{ display: "block" }}
      className="w-full h-16 md:h-20"
    >
      <path d="M0,0 L1440,80 L1440,80 L0,80 Z" fill={bottomColor} />
    </svg>
  </div>
);
